enum HitVFXType {
  NONE,
  DEFAULT,
  TIMEFREEZE,
  FIRE,
  DARK,
  LIGHT,
  PUSH,
}

export default HitVFXType;
